import { defineStore } from 'pinia'

export interface WithdrawalMerchantItem {
  partnerId: string
  partnerName: string
  withdrawAmount: string
  huifuId?: string
  bankName?: string
  cardNo?: string
}

export interface LeagueWithdrawalData {
  clubId: string
  clubName: string
  merchants: WithdrawalMerchantItem[]
}

const initialState: LeagueWithdrawalData = {
  clubId: '',
  clubName: '',
  merchants: [],
}

export const useLeagueWithdrawalStore = defineStore(
  'leagueWithdrawal',
  () => {
    const withdrawalData = ref<LeagueWithdrawalData>({ ...initialState, merchants: [] })

    function setWithdrawalData(data: LeagueWithdrawalData) {
      withdrawalData.value = data
    }

    function clearWithdrawalData() {
      withdrawalData.value = { ...initialState, merchants: [] }
    }

    return {
      withdrawalData,
      setWithdrawalData,
      clearWithdrawalData,
    }
  },
)
